<div class="flex flex-col max-w-240 md:min-w-160 -m-6">

    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{hdng_nm}} Holidays</div>
        <button mat-icon-button (click)="Close()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="close"></mat-icon>
        </button>
    </div>
    <fuse-alert
                class="mt-8 -mb-4 mx-10"
                *ngIf="showAlert"
                [appearance]="'soft'"
                [showIcon]="false"
                [type]="alert.type"
                [@shake]="alert.type === 'error'">
                {{alert.message}}
            </fuse-alert>
    <form [formGroup]="holidayForm" class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
       

        
        <div class="flex flex-row">
            <!-- <mat-form-field class="frmfld m-2">
                <mat-label>Select Date</mat-label>
                <mat-select formControlName="date_id" placeholder="Select Date" #select1 (selectionChange)="onDateChange($event)">
                    <mat-select-filter *ngIf="select1.focused" [array]="variables" (filteredReturn)="dateLst =$event"></mat-select-filter>
                    <mat-option *ngFor="let d of dateLst" [value]="d.dt_id">{{d.dt}}
                    </mat-option>
                </mat-select>
            </mat-form-field> -->
            <mat-form-field class="frmfld m-2">
                <mat-label>Select Date</mat-label>
            <input matInput [matDatepicker]="picker" placeholder="Choose Date"  formControlName="date_id">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="flex flex-row">
            <mat-form-field class="frmfld m-2">
                <mat-label>Holiday Name</mat-label>
                <input matInput  formControlName="hldy_nm">
            </mat-form-field>
        </div>
        <div class="flex flex-row">
            <mat-form-field class="frmfld m-2">
                <mat-label>Description</mat-label>
                <textarea matInput
                class="w-full"
                formControlName="dsc_txt"
                ></textarea>
            </mat-form-field>
        </div>
        
         
        
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">
            </div>
            <div class="flex items-center mt-4 sm:mt-0">
                <button class="ml-auto sm:ml-0 m-2" mat-button (click)="Close()">
                    Cancel
                </button>

                <button class="order-first sm:order-last m-2" mat-flat-button [color]="'primary'" (click)="send()">
                    {{sve_btn}}
                </button>
            </div>
        </div>

    </form>
</div>